import { Exact } from "src/generated/graphql";
import { gql } from "apollo-angular";
import { Injectable } from "@angular/core";
import { Apollo, Query } from "apollo-angular";
import { AwardCriteria } from "./awardCriteria.graphql";

export type GetAwardCriteriaQueryVariables = Exact<{ [key: string]: never }>;

export type GetAwardCriteriaQuery = {
  getAwardCriterias: [AwardCriteria];
};

export const GetAwardCriteriaDocument = gql`
  query GetAwardCriterias {
    getAwardCriterias {
      id
      individual
      team
      numberOfPoints
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class GetAwardCriteriaGQL extends Query<
  GetAwardCriteriaQuery,
  GetAwardCriteriaQueryVariables
> {
  document = GetAwardCriteriaDocument;

  constructor(apollo: Apollo) {
    super(apollo);
  }
}
